import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function RoutedThroughIntegration({ node }) {
    var _a;
    return (_jsxs(_Fragment, { children: ["Integration ", _jsx("strong", { children: node.http_request_type }), " \u00B7", ' ', ((_a = node.variables) === null || _a === void 0 ? void 0 : _a.length) ? (_jsxs(_Fragment, { children: ["Variables ", _jsx("strong", { children: node.variables.join(', ') })] })) : ('No variables created')] }));
}
